import { createAction } from "@reduxjs/toolkit";

import {
  addStripeActionType,
  clearStripeActionType,
  getStripeCountriesActionTypes,
} from "./actionTypes";

export const addStripe = createAction(addStripeActionType.request);

export const addStripeSuccess = createAction(
  addStripeActionType.success,
  (payload) => ({ payload }),
);

export const addStripeFailure = createAction(
  addStripeActionType.failure,
  (error) => ({ payload: error }),
);

export const clearAddStripeStates = createAction(clearStripeActionType.reset);

export const getStripeCountries = createAction(
  getStripeCountriesActionTypes.request,
);
export const getStripeCountriesSuccess = createAction(
  getStripeCountriesActionTypes.success,
);
export const getStripeCountriesFailure = createAction(
  getStripeCountriesActionTypes.failure,
);
